import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 1680,
	height: 481,
	fill: "none",
	viewBox: "0 0 1680 481",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#2A4572",
			d: "m1514.11 103.77 135.52 47.8A50 50 0 0 1 1683 198.7V308a50 50 0 0 1-50 50H-106.9c-44.24 0-66.69-53.23-35.8-84.9L59.05 66.21a50 50 0 0 1 64.86-5.78l33.49 23.93a51.81 51.81 0 0 0 43.4 7.71c46.35-12.24 151.6-37.1 226.46-32.6 54.15 3.25 129.08 24.05 162.14 33.92a51.72 51.72 0 0 0 33.32-1.14l54.97-21.05c18.6-7.12 39.32-2 55.5 9.6 5.22 3.75 10.72 7.16 15.88 9.36C791.6 108.3 842.27 58.2 871.9 21.9c15.41-18.88 41.46-26.94 63.88-17.4l190.49 80.99a52.16 52.16 0 0 0 22.91 4.01c18.26-.86 53.7-2 78.83.66 43.62 4.61 102.47 25.54 130.32 36.2a52.26 52.26 0 0 0 32.4 1.77l93.63-25.47a49.98 49.98 0 0 1 29.75 1.1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#456090",
			d: "M166.53 226.78 31.34 274.55A50 50 0 0 0-2 321.69v108.87a50 50 0 0 0 50.44 50l1580-13.84a50 50 0 0 0 49.56-50V227.06c0-34.96-34.96-59.13-67.67-46.77l-93.52 35.33a51.84 51.84 0 0 1-31.95 1.41c-41.56-11.27-154.39-39.3-233.36-34.55-54.02 3.25-128.75 24.02-161.79 33.9a51.73 51.73 0 0 1-33.37-1.14l-54.73-21c-18.62-7.14-39.36-2-55.56 9.63-5.2 3.72-10.65 7.1-15.79 9.3-42.42 18.13-92.97-31.9-122.55-68.19-15.42-18.91-41.5-26.98-63.94-17.42l-190 80.92a52.14 52.14 0 0 1-22.94 4.03c-18.24-.87-53.58-2-78.65.66-43.52 4.61-102.21 25.51-130.04 36.17a52.28 52.28 0 0 1-32.45 1.79l-93.35-25.44a50 50 0 0 0-29.8 1.1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#C3D0E6",
			d: "M1373.73 300.25c153.01-7.56 250.22-13.85 390.17 33.08C1822.86 353.1 1905 398 1905 398H35s463.81-40 560.4-49.63c152.36-15.18 238.97 34.06 392.18 24.81 155.02-9.35 230.96-65.27 386.15-72.94Z"
		})
	]
});
const SvgMountainsBg = styled(base)({});
export default SvgMountainsBg;
